// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__2pBDF"};